/**
 * ImageZoomModal - Full-screen image view modal
 */
import { memo } from 'react';
import { X } from 'lucide-react';
import { Dialog, DialogContent, DialogTitle } from '../ui/dialog';

const ImageZoomModal = memo(function ImageZoomModal({ 
  isOpen, 
  onClose, 
  item, 
  formatPriceRange 
}) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-4xl p-0 bg-transparent border-none">
        <DialogTitle className="sr-only">{item.name} - Zoomed Image</DialogTitle>
        <div className="relative">
          {item.image && (
            <img 
              src={item.image} 
              alt={item.name}
              className="w-full h-auto max-h-[80vh] object-contain rounded-lg"
            />
          )}
          <button
            onClick={() => onClose(false)}
            className="absolute top-4 right-4 p-2 bg-black/60 hover:bg-black/80 rounded-full text-white"
            aria-label="Close zoom"
          >
            <X className="w-5 h-5" />
          </button>
          {/* Item info overlay at bottom */}
          <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black/80 to-transparent rounded-b-lg">
            <h3 className="font-heading text-xl text-white">{item.name}</h3>
            <p className="text-white/80 text-sm mt-1">{item.description}</p>
            <p className="text-primary font-bold text-lg mt-2">{formatPriceRange()}</p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
});

export default ImageZoomModal;
